export default __webpack_public_path__ + "static/og-image-0ad93c1beba7b12414569d86f9ac66d3.png";